<script>
import { mapGetters } from "vuex";

export default {
  name: "nav",
  data() {
    return {
      permissionList: [],
      sidebar: {
        _name: "CSidebarNav",
        _children: [
          {
            _name: "CSidebarNavItem",
            name: "แชท",
            to: "/d-chatbot",
            icon: "cil-chat-bubble",
            permission: 50,
          },
          {
            _name: "CSidebarNavItem",
            name: "ดี-ออร์เดอร์",
            to: "/d-order",
            icon: "cil-list",
            permission: 51,
          },
          {
            _name: "CSidebarNavItem",
            name: "ออร์เดอร์",
            to: "/order",
            icon: "cil-list",
            permission: 10,
          },
          {
            id: 2,
            _name: "CSidebarNavDropdown",
            name: `จัดการธุกรรม`,
            icon: "cil-settings",
            permission: 52,
            _children: [
              {
                _name: "CSidebarNavItem",
                name: `รายการธุรกรรม`,
                to: "/finance",
                icon: "cis-circle",
                permission: 53,
              },
              {
                _name: "CSidebarNavItem",
                name: `ภาพรวมการสั่งซื้อ`,
                to: "/finance/order-list",
                icon: "cil-circle",
                permission: 54,
              },
            ],
          },
          {
            id: 1,
            _name: "CSidebarNavDropdown",
            name: `ตั้งค่าอีคอมเมิร์ซ`,
            icon: "cil-settings",
            permission: 55,
            _children: [
              {
                _name: "CSidebarNavItem",
                name: `สินค้า`,
                to: "/product",
                icon: "cis-circle",
                permission: 7,
              },
              {
                _name: "CSidebarNavItem",
                name: `การกระจายสินค้า`,
                to: "/inventory",
                icon: "cil-circle",
                permission: 56,
              },
              {
                _name: "CSidebarNavItem",
                name: `การจัดส่ง`,
                to: "/shipping",
                icon: "cil-circle",
                permission: 43,
              },
              {
                _name: "CSidebarNavItem",
                name: `โปรโมชัน`,
                to: "/promotion",
                icon: "cil-circle",
                permission: 9,
              },
            ],
          },
           {
            _name: "CSidebarNavItem",
            name: "รายการผู้ดูแลระบบ",
            to: "/admin",
            icon: "cil-settings",
            permission: 22,
          },
        ],
      },
    };
  },
  computed: {
    sidebarItems() {
      return [
        {
          _name: "CSidebarNav",
          _children: this.filterMenuByPermission(this.sidebar._children),
        },
      ];
    },
    ...mapGetters([
      "getCurrentBrandID",
    ]),
  },
  created: async function () {
    await this.getPermissionList();
  },
  methods: {
    getPermissionList: async function () {
      let permissions = this.$store.getters.getUserPermissionsList();
      let currentBrandID = await this.$route.query.brandID;
      let permissionListByBrandId = await permissions.filter((el) => {
        return el.brandId == currentBrandID;
      });
      this.permissionList = permissionListByBrandId[0].permission;
    },
    filterMenuByPermission(list) {
      var menus = this.filterPermission(list);
      menus.forEach((element) => {
        if (element._children) {
          element._children = this.filterPermission(element._children);
          element._children.forEach((element2) => {
            if (element2._children) {
              element2._children = this.filterPermission(element2._children);
            }
          });
        }
      });

      return menus;
    },
    filterPermission(list) {
      var t = list.filter((item) => {
        return this.permissionList.indexOf(item.permission) > -1;
      });
      return t;
    },
  },
};
</script>
